import { GamePackIcon } from '@/API';
import CenterFixedShape from './BackgroundElements/CenterFixedShape';
import CenterLineElement from './BackgroundElements/CenterLineElement';
import {
  loadingPaletteColors,
  elementsTransition,
  getSelectedGamePackIcon
} from '@/utils/gamePacks';
import { motion } from 'motion/react';

export default function ContentBackground({
  gamePackIcon,
  updateKey,
  loading
}: {
  gamePackIcon: GamePackIcon;
  updateKey: string;
  loading: boolean;
}) {
  const icon = getSelectedGamePackIcon(gamePackIcon);
  return (
    <div className="h-full w-full absolute z-0 overflow-hidden" key={updateKey}>
      <CenterLineElement
        className="absolute top-426 right-203"
        initial={loading ? { scale: 1 } : { scale: 0.5 }}
        animate={{ scale: 1 }}
        transition={elementsTransition}
      />
      <CenterFixedShape
        color={loading ? loadingPaletteColors.fill : ''}
        className="absolute top-210 left-86"
        initial={loading ? { scale: 1 } : { scale: 0.5 }}
        animate={{ scale: 1 }}
        transition={elementsTransition}
      />
      {icon && !loading && (
        <motion.img
          src={icon.icons.big}
          alt={icon.label}
          className="absolute -rotate-15 top-92 right-192 @8xl:right-292 w-250"
          initial={{ scale: 0.5 }}
          animate={{ scale: 1 }}
          transition={elementsTransition}
        />
      )}
    </div>
  );
}
